import { gql } from 'apollo-angular';
import { environment } from '@env/environment';
import { extractQueryFields } from '@common/core/utils/graphql.utils';

const queryFields = extractQueryFields(environment.apiProperties);

export const SHIP_FROM_STORE_LIST_FIELDS = gql`
  fragment ShipFromStoreListFields on object_ShipFromStore {
    id
    orderNumber
    status
    creationDate
    customerFullName
    newAt
    onHoldAt
    order {
      ... on object_SalesOrder {
        id
        paymentStatus
        fulfillmentStatus
        orderNumber
      }
    }
  }
`;

export const SHIP_FROM_STORE_NESTED_ORDER = gql`
  fragment ShipFromStoreOrderFields on object_SalesOrder {
    id
    orderNumber
    orderDate
    customerFirstname
    customerLastname
    paymentStatus
    fulfillmentStatus
    #    orderHistory { FIXME
    #      event
    #      eventDate
    #    }
    paymentInfo {
      ... on fieldcollection_PaymentInfo {
        shopAmount
        shopCurrency
        customerAmount
        customerCurrency
        paymentStatus
        gateway
        paymentKind
      }
    }
    currency
    deliveryCompany
    deliveryStreet
    deliveryCity
    deliveryZip
    deliveryProvince
    deliveryCountry
    customerFirstname
    customerLastname
    customerFullName
    customerEmail
    customerStreet
    customerCity
    customerZip
    customerCompany
    customerProvince
    customerProvinceCode
    customerCountry
    customerPhone
    totalPrice
    salesOrderItems {
      ... on object_SalesOrderItem {
        id
        quantity
        productName
        totalPrice
        product {
          ... on object_Product {
            sku
            images {
              ... on fieldcollection_ImageInfo {
                image {
                  filename
                  fullpath
                }
              }
            }
            ${queryFields}
            parent {
              ... on object_Product {
                sku
                images {
                  ... on fieldcollection_ImageInfo {
                    image {
                      filename
                      fullpath
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const SHIP_FROM_STORE_ITEMS = gql`
  fragment ShipFromStoreItems on object_ShipFromStoreItem {
    id
    qty
    productSku
    orderItem {
      ... on object_SalesOrderItem {
        id
        quantity
        productName
        totalPrice
        product {
          ... on object_Product {
            sku
            images {
              ... on fieldcollection_ImageInfo {
                image {
                  filename
                  fullpath
                }
              }
            }
            ${queryFields}
            parent {
              ... on object_Product {
                sku
                images {
                  ... on fieldcollection_ImageInfo {
                    image {
                      filename
                      fullpath
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const accessoryFileQuery = environment.shipFromStore.isUploadAccessoryFileEnabled
  ? `accessoryFile {
    ... on asset {
      filename
      fullpath
    }
  }`
  : ``;

export const SHIP_FROM_STORE_DETAILS_FIELDS = gql`
  ${SHIP_FROM_STORE_NESTED_ORDER}
  ${SHIP_FROM_STORE_ITEMS}
  fragment ShipFromStoreFields on object_ShipFromStore {
    id
    customerFullName
    orderNumber
    status
    newAt
    packedAt
    sentToLogisticAt
    canceledAt
    onHoldAt
    creationDate
    assignmentHistory {
      event
      eventDate
    }
    items {
      ...ShipFromStoreItems
    }
    shippingLabel {
      ... on asset {
        filename
        fullpath
      }
    }
    proformaInvoice {
      ... on asset {
        filename
        fullpath
      }
    }
    ${accessoryFileQuery}
    order {
      ...ShipFromStoreOrderFields
    }
  }
`;
